// @ts-nocheck
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import useCanOnlyOrderSample from "@store/Framework/Common/Hooks/samples/useCanOnlyOrderSample";
import useCanOrderSample from "@store/Framework/Common/Hooks/samples/useCanOrderSample";
import useSampleProductContext from "@store/Framework/Common/Hooks/samples/useSampleProductContext";
import ProductAddToCartButton, {
    ProductAddToCartButtonProps,
    ProductAddToCartButtonStyles,
} from "@store/Overrides/Components/ProductAddToCartButton";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { useCanAddToCart, useHasEnoughInventory } from "@toolkit/Framework/Store/Data/Products/ProductsHooks";
import React, { FC, useContext, useMemo } from "react";
import { css } from "styled-components";

export const useShowProductAddSampleToCartButton = () => {
    return useCanOrderSample(useContext(ProductContext).product);
};

export const useIsProductAddSampleToCartButtonAvailable = (
    configurationCompleted: boolean | undefined,
    variantSelectionCompleted: boolean | undefined,
) => {
    const productContext = useSampleProductContext(useContext(ProductContext));
    const hasEnoughInventory = useHasEnoughInventory(productContext);
    const canAddToCart = useCanAddToCart(
        productContext.product,
        productContext.productInfo,
        configurationCompleted,
        variantSelectionCompleted,
    );

    return canAddToCart && hasEnoughInventory;
};

export interface ProductAddSampleToCartButtonProps extends ProductAddToCartButtonProps {}

export interface ProductAddSampleToCartButtonStyles extends ProductAddToCartButtonStyles {}

export const productAddSampleToCartButtonStyles: ProductAddSampleToCartButtonStyles = {
    button: {
        mergeCss: true,
        variant: "secondary",
        css: css`
            padding: ${pxToRem(0, 10)};
        `,
    },
};

const ProductAddSampleToCartButton: FC<ProductAddSampleToCartButtonProps> = ({
    configurationCompleted,
    extendedStyles: baseExtendedStyles,
    variantSelectionCompleted,
    ...addToCartButtonProps
}) => {
    const { product } = useContext(ProductContext);
    const isAvailable = useIsProductAddSampleToCartButtonAvailable(configurationCompleted, variantSelectionCompleted);

    const canOnlyOrderSample = useCanOnlyOrderSample(product);
    const extendedStyles = useMemo(() => {
        return mergeProps<ProductAddSampleToCartButtonStyles>(productAddSampleToCartButtonStyles, {
            ...baseExtendedStyles,
            button: {
                variant: canOnlyOrderSample ? "primary" : "secondary",
                ...baseExtendedStyles?.button,
            },
        });
    }, [baseExtendedStyles, canOnlyOrderSample]);

    if (!useShowProductAddSampleToCartButton()) {
        return null;
    }

    return (
        <ProductAddToCartButton
            {...addToCartButtonProps}
            configurationCompleted={configurationCompleted}
            extendedStyles={extendedStyles}
            isDisabled={!isAvailable}
            isSample={true}
            labelOverride={isAvailable ? translate(`Order Sample`) : translate(`Sample Unavailable`)}
            variantSelectionCompleted={variantSelectionCompleted}
        />
    );
};

export default ProductAddSampleToCartButton;
